export default __webpack_public_path__ + "static/media/calendar.8eac6920.svg";